import { Link } from 'react-router-dom'

/**
 * Shown in place of the trainer picker when nothing matches the qualification filter.
 *
 * Previously most of these pickers simply hid the whole section when no trainer was qualified,
 * which reads as "this feature is missing" rather than "nobody is qualified yet" — and gave no
 * hint that qualifications are managed on the Trainers page.
 */
export function NoEligibleTrainers({ hasCourse, hasAnyTrainers }: {
  /** A course is selected, so the qualification filter is actually being applied. */
  hasCourse: boolean
  /** The tenant has at least one active trainer (regardless of qualification). */
  hasAnyTrainers: boolean
}) {
  if (!hasCourse) {
    return <p className="text-sm text-gray-400">Select a course to see eligible trainers.</p>
  }

  return (
    <p className="text-sm text-gray-500">
      {hasAnyTrainers
        ? 'No trainers are qualified for this course yet.'
        : "You haven't added any trainers yet."}{' '}
      <Link to="/admin/trainers" className="text-indigo-600 hover:text-indigo-700 underline">
        {hasAnyTrainers ? 'Manage qualifications' : 'Add a trainer'}
      </Link>
    </p>
  )
}
